import userApi from "./index"

export const getQuestions = async (filters) => {
  console.log({ filters }, "this is data")

  try {
    const {
      subjectId,
      topicIds,
      subtopicIds,
      chapterIds,
      sectionIds,
      paperType,
      year,
      search,
      page = 1,
      limit = 10,
      mark,
      match,
    } = filters
    const queryParams = new URLSearchParams()

    if (subjectId) queryParams.append("subjectId", subjectId)
    if (topicIds) queryParams.append("topicIds", topicIds)
    if (subtopicIds) queryParams.append("subtopicIds", subtopicIds)
    if (chapterIds) queryParams.append("chapterIds", chapterIds)
    if (sectionIds) queryParams.append("sectionIds", sectionIds)
    // Optional additive/strict filtering across dimensions (topics/subtopics/chapters/sections)
    // Backend default is match=all; only send when explicitly requested.
    if (match === "any" || match === "all") queryParams.append("match", match)
    if (paperType) queryParams.append("paper", paperType)
    if (year) queryParams.append("year", year)
    if (search) queryParams.append("searchText", search)
    if (mark) queryParams.append("marks", mark)
    queryParams.append("page", page)
    queryParams.append("limit", limit)

    const response = await userApi.get(`/questions?${queryParams.toString()}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getQuestionById = async (id) => {
  try {
    const response = await userApi.get(`/question/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

// New tree-search endpoint (OR across branches, AND down each branch path)
// POST /api/user/questions/search
export const searchQuestions = async (body) => {
  try {
    const response = await userApi.post(`/questions/search`, body)
    return response.data
  } catch (error) {
    throw error
  }
}
